module.exports = __webpack_public_path__ + "img/Ford.a2a5756f.png";